<template>
  <div ref="pageRoot">
    <NetworkStatus v-if="isOffline" />
    <div v-else>
   <div class="modal fade" id="staticBackdrop51" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <SequenceModal/>
  </div>
  <div class="modal fade" id="staticBackdrop52" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <StopcourseModal />
  </div>
  <div class=" container-fluid" >
    <div class="row">
      <div class="col-lg-12  py-0 ">
        <div class="row items mt-n1">
          <div class="row d-flex justify-content-end" >
            <div class="col-md-4 ">
              <div class="container d-flex mt-3 ">
                <div class="legend d-flex" v-if="selectedOption === 'default'" >
                  <span class="lg1 bg-gradient-warning" > </span> <span style="font-size: 15px;" class="mx-2">{{ $t("classroom.code_pending") }}</span>
                </div>
                <div class="legend d-flex" style="margin-left: 20px" v-if="selectedOption === 'default'" >
                  <span class="lg2 bg-gradient-danger"></span> <span class="mx-2" style="font-size: 15px;"> {{ $t("classroom.code_overdue") }}</span>
                </div>

                <div class="legend d-flex" v-if="selectedOption === 'option1'">
                  <h5>{{ $t("classroom.code_pending") }} </h5>
                </div>
                <div   class="legend d-flex" v-if="selectedOption === 'option3'" >
                  <h5>{{ $t("classroom.code_overdue") }}  </h5>
                </div>
              </div>
            </div>
            
            <div class="col-md-8  px-0">
              <div class="action-buttons mt-3 d-flex flex-wrap justify-content-end align-items-center gap-3">
                <!-- Alert Dropdown -->
                <div class="dropdown">
                  <button class="btn dropdown-toggle text-light " type="button" data-bs-toggle="dropdown">
                    <span class="icon-alert text-light me-1 fw-bold">
                      <i class="text-light bi bi-lightning-charge-fill"></i>
                        {{ $t("studentlist.alert") }}
                    </span>
                  
                  </button>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item" data-bs-toggle="modal" data-bs-target="#staticBackdrop51">
                      {{$t("studentlist.sequence_date") }}
                    </li>
                    <li class="dropdown-item" data-bs-toggle="modal" data-bs-target="#staticBackdrop52">
                      {{$t("studentlist.course_suspension") }}
                    </li>
                  </ul>
                </div>
                <div class="dropdown">
                  <button class="btn dropdown-toggle text-light fw-bold" type="button" data-bs-toggle="dropdown">
                   <span> <i class="icon-filter text-success fa fa-sliders me-1"></i>
                    {{$t("classroom.filter") }}
                  </span>
                  </button>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item" @click="selectOption('default')">
                      {{ $t("classroom.filter_option1") }}
                    </li>
                    <li class="dropdown-item" @click="selectOption('option1')">
                      <div class="d-flex justify-content-between align-items-center">
                        <span >{{ $t("classroom.filter_option2") }}</span>
                        <span class="badge bg-warning">{{ pendingCount }}</span>
                      </div>
                    </li>
                    <li class="dropdown-item" v-show="false" @click="selectOption('option3')">
                      <div class="d-flex justify-content-between align-items-center">
                        <span>{{ $t("classroom.filter_option3") }}</span>
                        <span class="badge bg-danger">{{ overdueCount }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- classroom-setup button moved to Settings -->
                <router-link :to="{ name: 'new-class' }">
                  <button class=" btn bg-gradient-success text-light">
                     <span class="fa fa-plus-circle me-2"></span>
                  {{ $t("classroom.button_new_class") }}
                  </button>
                </router-link>
              </div>
          </div>
          </div>
          <!--
            Les deux modèles de documents de l'établissement — certificat de
            scolarité et reçu de paiement — côte à côte : ce sont deux
            configurations de même nature, faites une fois puis rarement
            revisitées. Les empiler pousserait les indicateurs de classe, qui
            sont l'information principale de l'écran, hors de la première vue.

            Seuls les modèles restant à configurer s'affichent ici : une fois
            enregistrés, ils rejoignent les paramètres. La colonne suit sa
            bannière, faute de quoi une bannière partie dans les paramètres
            laisserait une demi-largeur vide au milieu de l'écran.
          -->
          <div
            class="document-banners certificate-banner-compact mt-3"
            v-if="showCertificateBanner || showReceiptBanner"
          >
            <div class="row g-3">
              <div :class="bannerColumnClass" v-if="showCertificateBanner">
                <certificate-banner />
              </div>
              <div :class="bannerColumnClass" v-if="showReceiptBanner">
                <payment-receipt-banner />
              </div>
            </div>
          </div>
          <classroom-stats class="mt-3" />
          
          <div class="mt-n4" v-if="selectedOption === 'default'">
            <classes-list-card />
          </div>
          <div class="mt-n4" v-if="selectedOption === 'option1'">
            <classes-list-card2 />
          </div>
          <div class="mt-n4"  v-if="selectedOption === 'option3'">
            <classes-list-card3 />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>  

  </div>
</template>

<script>
import { getdashboardreport } from "@/utils/services";
import ClassesListCard from "@/views/Classroom/ClassListCard";
import ClassesListCard2 from "@/views/Classroom/ClassListCard2";
import ClassesListCard3 from "@/views/Classroom/ClassListCard3";
import SequenceModal from "../modal/sequencemodal.vue"
import StopcourseModal from "../modal/stopcoursemodal.vue"
import NetworkStatus from "@/views/components/NetworkStatus.vue";
import ClassroomStats from "@/views/Classroom/ClassroomStats.vue";
import CertificateBanner from "@/views/Classroom/CertificateBanner.vue";
import PaymentReceiptBanner from "@/views/Classroom/PaymentReceiptBanner.vue";
import {
  isCertificateConfigured,
  isReceiptConfigured,
  loadCertificateFromApi,
  loadReceiptFromApi,
} from "@/utils/classroomSetup";
 

export default {
  name: "school-classes",
  data() {
    return {
      selectedOption: 'default',
      pending_count:0,
      pendingCount: 0,
      overdueCount: 0,
      isLocal: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
      isOffline: false,  
      apiError: false,
    };
  },
  components: {
    ClassesListCard,
    ClassesListCard2,
    ClassesListCard3,
    SequenceModal,
    StopcourseModal,
    NetworkStatus,
    ClassroomStats,
    CertificateBanner,
    PaymentReceiptBanner,
  },

  computed: {
    /*
     * Bannières de documents : seules celles qui restent à configurer
     * s'affichent ici, un modèle enregistré vivant dans les paramètres.
     */
    showCertificateBanner() {
      return !isCertificateConfigured();
    },
    showReceiptBanner() {
      return !isReceiptConfigured();
    },
    /* Seule à l'écran, une bannière prend toute la largeur plutôt que de
       laisser la moitié droite vide. */
    bannerColumnClass() {
      return this.showCertificateBanner && this.showReceiptBanner ? "col-lg-6" : "col-12";
    },
  },
   

  async mounted() {
    /*
     * État des modèles de documents : c'est lui qui décide si la bannière
     * s'affiche ici ou dans les paramètres. Le cache local peut être en
     * retard sur le serveur, et les bannières ne sont plus montées d'office
     * ici pour aller le demander elles-mêmes.
     *
     * Sans `await` : la valeur est réactive, l'écran se met à jour seul.
     */
    loadCertificateFromApi(this.$i18n.locale);
    loadReceiptFromApi();

    await this.updateOnlineStatus();
    this.$nextTick(() => {
      const root = this.$refs.pageRoot;
      const dropdownElements = root && typeof root.querySelectorAll === 'function'
        ? root.querySelectorAll('.dropdown-toggle')
        : [];

      dropdownElements.forEach((dropdownToggleEl) => {
        if (window.bootstrap && window.bootstrap.Dropdown) {
          const existingDropdown = window.bootstrap.Dropdown.getInstance(dropdownToggleEl);
          if (existingDropdown) {
            existingDropdown.dispose();
          }
          new window.bootstrap.Dropdown(dropdownToggleEl, { autoClose: true });
        }
      });
    });

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.intervalId = setInterval(this.checkInternetConnection, 1000);
    await this.fetchDashboardData();

    if (!this.isOffline) {
      
      await this.fetchDashboardData();
    }
  },

  beforeUnmount() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },


  methods: {

    async updateOnlineStatus() {
    if (navigator.onLine) {
      try {
        // Vérifier si les API sont accessibles
        await this.checkConnection();
        this.isOffline = false; // Tout fonctionne, on est en ligne
      } catch (error) {
        console.error("Error checking connection:", error);
        this.isOffline = true; // Les API ne répondent pas, on est hors ligne
      }
    } else {
      // Pas de connexion internet détectée
      this.isOffline = true;
    }
  },

  async checkConnection() {
    try {
      await Promise.all([
        getdashboardreport()
      ]);
      this.apiError = false;
    } catch (error) {
      console.error("API Error:", error);
      this.apiError = true;
    }
  },
    selectOption(option) {
      this.selectedOption = option;
    },

    async fetchDashboardData() {
      try {
        this.loading = true;
        this.dashboardData = await getdashboardreport();
        if (this.dashboardData) {
          this.pendingCount = this.dashboardData.pending.count || 0;
          this.overdueCount = this.dashboardData.payment_overdue.count || 0;
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        this.loading = false;
      }
    },
  }
};




</script>

<style scoped>
.items {
  margin-top: 5vh;
}

.btn {
  height: 55px;
  min-width: 150px;
  background: #111c44;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
  margin-top: -20px;
}

.dropdown-toggle{
  display: flex;
  justify-content: space-between;
  width: 150px;
}

.dropdown-menu {
  width: 250px;
  background: #1a2547;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0;
  border-radius: 4px;
}

.dropdown-item {
  padding: 12px 20px;
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}


#filter {
  width: max-content;
  margin-top: 30px;
  margin-left: auto;
  border: 1px solid rgba(255, 255, 255, 0.1);
 
  z-index: 2;

}

#filter .dropdown .dropdown-menu {
  width: 250px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0;
  border-radius: 0;



}

#filter .dropdown .dropdown-menu li {
  padding: 10px 20px;
  width: auto;
  color: white;

}

#filter .dropdown .icon-filter {

  transform: translateX(-10px);
  font-weight: bold;

}

#filter .dropdown .dropdown-menu .li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: 0.3s;
}

#filter .dropdown .dropdown-menu li:hover {
  background: rgba(255, 255, 255, 0.1);
}

#filter .dropdown .btn {
  height: 55px;
  width: 150px;
  margin-top: -30px;
  font-size: 15px;
  font-weight: bold;

}

.items .lg1 {
  display: block;
  transform: translateY(5px);
  content: "";
  height: 15px;
  width: 15px;
  border-radius:2px;
   
}

.certificate-banner-compact {
  width: calc(100% - 25px);
  margin-left: 30px;
}
.items .lg2 {
  display: block;
  transform: translateY(5px);
  content: "";
  height: 15px;
  width: 15px;
  border-radius:2px;
   

}

#pend{
  padding: 2px 4px;
  font-size: 10px;
  border-radius:2px;
}

#sett{
    padding: 2px 4px;  
    font-size: 12px;
    border-radius:2px; 
  }


  .icon-alert {
  color: black;
  padding: 1px 4px;
  border-radius: 50%;
  


}

 


</style>

<style>
/*
  Mise en page des deux bannières de documents (certificat, reçu).

  Non scopé volontairement : `.cert-banner` et `.rcp-banner` appartiennent aux
  composants enfants, où un sélecteur scopé du parent n'atteint que leur
  élément racine. C'est aussi pourquoi les règles `.certificate-banner-compact
  .cert-banner` qui existaient ici n'avaient aucun effet.

  Les deux bannières sont mises à la même hauteur : côte à côte, deux cartes
  de hauteurs différentes donneraient un alignement bancal, l'une étant plus
  bavarde que l'autre selon qu'elle est configurée ou non.
*/
.document-banners .col-lg-6 > div,
.document-banners .cert-banner,
.document-banners .rcp-banner {
  height: 100%;
}

/* L'espacement vient des gouttières de la grille, pas des bannières. */
.document-banners .cert-banner,
.document-banners .rcp-banner {
  margin-bottom: 0;
}
</style>
